export default __webpack_public_path__ + "static/media/scholastic-logo-updated.f0a368e7.svg";